import { COLOR_MID_GRAY } from "../constants";
import { isDarkTheme } from "./config";
const lightGrey = "var(--Colors-Neutral-Neutral-50, #F8F8F8)"
const darkGrey = "var(--Colors-Neutral-Neutral-50, #2D2E2C)"
const LIGHT_COLORS = {
  bglightgrey: lightGrey,
  text: "#333333",
  bgwhite: "#ffffff",
  surfaceSecondary: lightGrey,
  border: `1px solid ${COLOR_MID_GRAY}`,
  bgDarkGrey: "var(--Colors-Neutral-Neutral-800, #515151)",
  paper: "#ffffff",
  description: 'grey.1000'
};

const DARK_COLORS = {
  bglightgrey: "#000000",
  text: "#f6f6f6",
  bgwhite: "#000000",
  surfaceSecondary: darkGrey,
  border: `1px solid ${darkGrey}`,
  bgDarkGrey: "var(--Colors-Neutral-Neutral-500, #979897)",
  paper: "#161616",
  description: '#d5c5c5'
};

export const getColors = () => {
  return isDarkTheme() ? DARK_COLORS : LIGHT_COLORS;
};

export const clampLines = (lines: number = 8) => ({
  display: "-webkit-box",
  WebkitLineClamp: lines,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
} as const);